import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Select,
  Dropdown,
  TreeSelect,
  Typography,
  InputNumber,
  Flex
} from "antd";
import {
  DeleteOutlined,
  QuestionCircleOutlined,
  DownOutlined,
  ShrinkOutlined,
  ExpandOutlined
} from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";

import UploadButton from "../../common/UploadButton";
import globalData from "../../../config/global_data";
import CreateMultiKitAttributeList from "./CreateMultiKitAttributeList";
// import MultiKitProductGroupList from "./MultiKitProductGroupList";
import MultiKitProductGroupList from "../MultiKitProductGroupList";
import common_api from "../../../config/common_api";
import { triggerNotification } from "../../common/notify";
const { Text } = Typography;


const CreateMultiKitDrawer = ({ visible, onClose, setisloader, selected_prod_data = null, onProductCreate }) => {
  const [form] = Form.useForm();
  const [data, setData] = useState(null);
  const [treeData, setTreeData] = useState(null)
  const [imageObj, setImageObj] = useState(null);
  const [bundleTitle, setBundleTitle] = useState("New Multi Kit Product");
  const [innerProducts, setInnerProducts] = useState({
    multi_kit_prods: [
      {
        id: uuidv4(), // first group id
        products: [
          {
            unique_id: uuidv4() // first product id
          }
        ]
      }
    ]
  });
  const [stores, setStoreOptions] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [savedimages, setSavedimgaes] = useState(null);
  const [dropdownImage, setDropdownImage] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [savedattributes, setSavedattributes] = useState(null);
  const [selectedStoreID, setSelectedStoreID] = useState(null);
  const [attributeResetToken, setAttributeResetToken] = useState(0);

  const ButtonItems = [
    {
      label: 'Save & Draft',
      key: 'saveDraft',
      disabled: true
    },
    {
      label: 'Save & Reload',
      key: 'saveReload',
      disabled: true
    },
  ];

  const handleInputChange = (name) => (e) => {
    let value = e.target.value;
    // Remove non-numeric characters except dot
    value = value.replace(/[^0-9.]/g, '');
    // Allow only one dot
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1]; // ignore extra dots
    }
  };
  const handleMenuClick = ({ key }) => {
    form
      .validateFields()
      .then((values) => {
        if (key === 'save') {
          onClose(); // Replace with your actual save logic
        }
      })
      .catch(() => {
        openNotification();
      });
  };

  const handleSaveAndPublishClick = () => {
    form
      .validateFields()
      .then((values) => {
        handleSaveAndPublish(values);
      })
      .catch(() => {
        openNotification();
      });
  };

  useEffect(() => {
    if (globalData.store_list && globalData.store_list.length > 0) {
      let final_storelist = globalData.store_list.filter(val => val.value != "all")
      setStoreOptions(final_storelist);
    }
    // savedimages(null)

    // setInnerProducts((prev) => ({
    //   ...prev,
    //   multi_kit_prods: [{ id: uuidv4(), products: [{}] }]
    // }));
    // form.setFieldsValue({ multi_kit_prods: [{id: uuidv4(), products: [{}]}] });
    // console.log("innerProducts ===>", innerProducts)
  }, []); // <-- run only once on mount

  
  useEffect(() => {
    if (innerProducts?.multi_kit_prods?.length) {
      form.setFieldsValue({ multi_kit_prods: innerProducts.multi_kit_prods });
    }
  }, [innerProducts]);
  
  const handleSaveAndPublish = async (values) => {
    // return 1
    // if (!innerProducts || innerProducts.length < 2) {
    //   triggerNotification({
    //     type: 'error',
    //     title: 'Error!',
    //     message: "Please Add Secondary and Primary Products",
    //   });
    //   return 1
    // }
    let images = []
    if (savedimages && savedimages.image_data && savedimages.image_data.length > 0) {
      images = savedimages.image_data.map(item => {
        if (item.is_saved) {
          return {
            id: item.is_saved,
            url_standard: item.thumbUrl
          }
        } else {
          return {
            image_url: item.thumbUrl
          }
        }
      })
    }
    let custom_fields_final = [], msrp = 0, sale_price = 0

    if (savedattributes && savedattributes.custom_fields && savedattributes.custom_fields.length > 0) {
      const data = savedattributes.custom_fields;
      data.forEach(attr => {
        const { pattern, values, attribute_key, max_size } = attr;
        let baseKey = attribute_key
        let counter = 1;

        values.forEach((item, index) => {
          if (item) {
            let itemobj = {}
            if (baseKey.includes("NUM")) {
              itemobj = {
                "name": baseKey.replace("NUM", counter),
                "value": item
              }
            } else if (max_size === 1) {
              itemobj = {
                "name": baseKey,
                "value": item
              }
            }
            else {
              itemobj = {
                "name": baseKey + "_" + counter,
                "value": item
              }
            }
            custom_fields_final.push(itemobj)
            counter++;
          }
        });
      });

    }

    if (values.DiscountValue) {
      custom_fields_final.push({
        "name": "DISCOUNT_%",
        "value": values.DiscountValue.toString()
      })
    }
    if (values.DropdownText) {
      custom_fields_final.push({
        "name": "KIT_PRODUCT_NAME",
        "value": values.DropdownText
      })
    }
    if (dropdownImage && dropdownImage.image_data && dropdownImage.image_data.length > 0) {
      custom_fields_final.push({
        "name": "KIT_IMG",
        "value": dropdownImage.image_data[0].thumbUrl
      })
    }

    const rawMultiKitData = form.getFieldValue("multi_kit_prods") || [];

    const multiKitData = innerProducts.multi_kit_prods.map((group, i) => {
      const { id, ...restGroup } = group;

      return ({
        ...restGroup,
        categoryMessage: rawMultiKitData[i]?.categoryMessage || "",
        categoryName: rawMultiKitData[i]?.categoryName || "",
        // categoriesName: group.categoriesName || [],
        products: (group.products || []).map((p) => ({
          productName: p.productName,
          sku: p.sku,
          image: p.image || "https://cdn11.bigcommerce.com/s-ww3msiylzo/images/stencil/original/image-manager/image-coming-soon.jpg",
          msrp: p.msrp,
          sale_price: p.sale_price
        }))
      });
    });
    // derive top-level price fields from first product in first group
    const firstVal = values.group?.[0]?.products?.[0] || {};
    msrp = firstVal?.msrp || 0;
    sale_price = firstVal?.sale_price || 0;

    let req_data = {
      "store": selectedStores,
      "data": {
        "name": values.KitName,
        "sku": values.bcsku,
        "intro_txt": values.IntroText,
        "custom_fields": custom_fields_final,
        "multi_kit_prods": multiKitData,
        "categories": selectedValues,
        "type": "physical",
        "weight": 0,
        "images": images && images.length > 0 ? images : [],
        price: parseFloat(values.price),
        sale_price: parseFloat(sale_price)
      },
      is_multi_kit_product: true
    }

    setisloader(true)
    let responsedata = await common_api.create_simple_product(req_data)
    if (responsedata) {
      setAttributeResetToken(prev => prev + 1);
      await onProductCreate();
      triggerNotification(responsedata)
      if (responsedata?.type === "success") {
        onClose()
      }
    }
    setisloader(false)
  }

  const openNotification = () => {
    triggerNotification({
      type: 'error',
      title: 'Form incomplete',
      message: "Please fix all errors before saving.",
    });
  };

  const handleBlur = () => {
    const bundleName = form.getFieldValue("KitName");
    if (bundleName && bundleName.trim()) {
      setBundleTitle(bundleName);
    } else {
      setBundleTitle("New Kit Product");
    }
  };

  const onChange = (values) => {
    setSelectedValues(values);
  };
  const store_options_handleChange = async (value) => {
    let store_id_data = await globalData.store_list.filter(item => item.value === value)
    if (globalData.all_cat_list && globalData.all_cat_list.length > 0) {
      let cattree = await globalData.all_cat_list.filter(item => item.store_id === store_id_data[0].store_id)
      if (cattree && cattree.length > 0) {
        setTreeData(cattree[0].treedata)
      }
    }
    setSelectedStoreID(store_id_data[0].store_id)
    setSelectedStores(value);
  };
  return (
    <Drawer className={`DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
      title={bundleTitle}
      width={isExpanded ? 'calc(100% - 256px)' : 600}
      onClose={onClose}
      open={visible}
      extra={
        <>
          <div className="DrawerButtonBox">
            <Button
              className="ExpandDrawer"
              onClick={() => setIsExpanded(!isExpanded)}
              style={{ marginRight: 8 }}
            >
              {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
            </Button>
            {/* <Button danger>
              <DeleteOutlined />
            </Button> */}
            <Dropdown.Button
              type="primary"
              icon={<DownOutlined />}
              menu={{
                items: ButtonItems,
                onClick: handleMenuClick,
              }}
              trigger={['click']}
              onClick={handleSaveAndPublishClick}
              style={{ marginLeft: 8 }}
            >
              Save & Publish
            </Dropdown.Button>
          </div>
        </>
      }
    >
      <Form layout="vertical" form={form}
        onValuesChange={(changedValues, allValues) => {
          if (changedValues.KitName !== undefined) {
            if (changedValues.KitName && changedValues.KitName.trim() !== "") {
              const formattedSku = changedValues.KitName.replace(/\s+/g, "-");
              form.setFieldsValue({ bcsku: formattedSku });
              setBundleTitle(changedValues.KitName);
            } else {
              form.setFieldsValue({ bcsku: "" });
              setBundleTitle("New Kit Product");
            }
          }
        }}
      >
        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlex" : ""}`}>
          <div className={`${isExpanded ? "w-33" : ""}`}>
          <Form.Item
              label={
                <span>
                  Multi Kit Name&nbsp;
                </span>
              }
              name="KitName"
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    const firstChar = value.charAt(0);
                    if (!value || value.trim() === "") {
                      return Promise.reject(new Error("Please enter Multi Kit Name"));
                    }
                    if (!firstChar.match(/[a-zA-Z0-9]/)) {
                      return Promise.reject(new Error("First character must be a letter or number"));
                    }

                    if (value.length > 255) {
                      return Promise.reject(new Error("Multi Kit Name cannot exceed 255 characters"));
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder="Enter a Multi Kit Name" onChange={handleBlur}/>
            </Form.Item>
          </div>
          <Flex className={`flexbox ${isExpanded ? "w-33" : ""}`}>
            <Form.Item label={
              <span>
                Store&nbsp;
              </span>} name="store" className="" style={{ width: "200px" }}
              rules={[{ required: true, message: "Please Select a Store" }]}>
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="Select Store"
                options={stores}
                onChange={store_options_handleChange}
              />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  BC SKU&nbsp;
                </span>
              }
              name="bcsku"
              rules={[{ required: true, whitespace: true, message: "Please Enter BC SKU" }
              ]}
            >
              <Input placeholder="Enter BC SKU" />
            </Form.Item>
          </Flex>

          <Form.Item
            label={
              <span>
                Default Price&nbsp;
              </span>
            }
            name="price"
            rules={
              [
                {
                  required: true,
                  validator: (_, value) => {
                    if (value === undefined || value === "") {
                      return Promise.reject("Please enter Default Price");
                    }
                    const num = Number(value);
                    if (isNaN(num)) {
                      return Promise.reject("Price must be a number");
                    }
                    if (num <= 0) {
                      return Promise.reject("Price must be greater than 0");
                    }
                    if (num > 10000000) {
                      return Promise.reject("Price must be less than or equal to 10000000");
                    }
                    return Promise.resolve();
                  }
                }
              ]
            }
          >
            <Input placeholder="Enter Default Price" onChange={handleBlur} />
          </Form.Item>

          <div className={`${isExpanded ? "w-33" : ""}`}>
            <Form.Item
              label={
                <span>
                  Product Categories&nbsp;
                </span>
              }
              title="Select categories from the tree."
              rules={[{ required: true, message: "Please select at least one category" }]}
            >
              <TreeSelect
                className="CategoryTree"
                multiple
                treeData={treeData}
                onChange={onChange}
                placeholder="Please select Categories"
                showSearch
                treeDefaultExpandAll
                treeNodeFilterProp="title"
              />

            </Form.Item>
          </div>
        </div>
        <Form.Item
          label={
            <span>
              PDP Gallery&nbsp;
            </span>
          }
          name="PDPGallery"
        >
          {visible && <UploadButton setSavedimgaes={setSavedimgaes}
            product_obj={null}
            MAX_UPLOADS="10"
            delete="true"
            replace="true"
            thumbnail="true"
            hover="" />}
        </Form.Item>

        <Form.Item
          label={
            <span>
              Intro Text&nbsp;
            </span>
          }
          name="IntroText"
          rules={[{ required: true, whitespace: true, message: "Please Enter Intro Text" }]}
        >
          <Input placeholder="Enter Intro Text" onChange={handleBlur} />
        </Form.Item>

        <Form.Item
          label={
            <span>
              Discount Value&nbsp;
            </span>
          }
          name="DiscountValue"
          rules={[
            { required: true, whitespace: true, message: "Please Enter Discount Value" },
            {
              validator: (_, value) => {
                if (value === undefined || value === "") {
                  return Promise.resolve(); // handled by 'required'
                }
                const numericValue = parseFloat(value);
                if (numericValue < 0 || numericValue > 100) {
                  return Promise.reject("Value must be between 1 and 100");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            placeholder="Enter Discount Value"
            style={{ width: "100%" }}
            onChange={handleInputChange("DiscountValue")}
            addonAfter="%"
            type="number"
          />
        </Form.Item>

        <div className="ProductDetailBox">
          <div className="ProductDetailBox_inner">
            {visible && <CreateMultiKitAttributeList setSavedattributes={setSavedattributes} resetToken={attributeResetToken} />}
            {/* {visible && selectedStoreID && <CreateKitProductList store_id={selectedStoreID} setInnerProducts={setInnerProducts} form={form} />} */}
            {visible && selectedStoreID && <MultiKitProductGroupList store_id={selectedStoreID} form={form} innerProducts={innerProducts} setInnerProducts={setInnerProducts} />}
          </div>
        </div>

      </Form>
    </Drawer>
  );
};

export default CreateMultiKitDrawer;